<template>
  <div class="general-search-container">

    <!-- ============================================================ -->
    <!-- 1) Medical Packages  -->
    <!-- ============================================================ -->
    <section id="MasterMedicalPackage" class="mb-10">
      <h3 class="section-title">{{ $t("OurPackages") }}</h3>

      <!-- Packages (Desktop) -->
      <div v-if="windowWidth >= 500" id="packages" style="width:65vw;margin:auto" class="vx-row mt-5">
        <div style="height: 15vw;" class="vx-col vx-col:w-1/2" v-for="(item,index) in medicalPackages" :key="index">
          <package-card
            :colorclass="item.BgColor"
            :item="item"
            :index="index"
            :iconImage="item.MedicalPackageCategory.IconImagePath"
            @OpenPackage="OpenPackage"
          />
        </div>
      </div>

      <!-- Packages (Mobile) -->
      <vs-row id="packages" class="mt-5 mb-5" vs-w="12" vs-justify="center" v-if="windowWidth <= 500">
        <vs-col
          v-for="item in medicalPackages"
          :key="item.id"
          class="mt-2"
          vs-type="flex"
          vs-justify="center"
          vs-align="center"
          vs-w="4"
          vs-sm="12"
        >
          <package-card-one
            class="mt-5"
            :colorclass="item.BgColor"
            :data="item"
            @OpenPackage="OpenPackage"
          />
        </vs-col>
      </vs-row>
    </section>

    <!-- ============================================================ -->
    <!-- 2) Surgery & Treatment  -->
    <!-- ============================================================ -->
    <section id="SAT" class="mb-15">
      <h3 class="section-title">{{ $t("SurgeryAndTreatment") }}</h3>

      <div style="width: 100%" class="hospitalListMobil">
        <SurgeryAndTreatmentsList
          :data="surgeryHospitals"
          v-if="surgeryHospitals.length > 0"
          @getSurgeries="getSurgeries"
        />
      </div>

      <h1
        style="text-align:center; cursor:pointer"
        v-if="IsShowMoreSurgery && surgeryHospitals && surgeryHospitals.length>0"
        @click="getNextHospitals"
      >{{ $t('ShowMore') }}</h1>
    </section>

    <!-- ============================================================ -->
    <!-- 3) Doctors -->
    <!-- ============================================================ -->
    <section id="docSearch" class="mb-15">
      <h3 class="section-title">{{ $t("Doctors") }}</h3>

      <div class="w-full mt-1">
        <doctor-list
          class="mt-5"
          v-for="item in searchDoctors"
          :key="item.ID"
          :doctor="item"
        />
      </div>

      <h1
        style="text-align:center; cursor:pointer"
        v-if="IsShowMoreDoctors && searchDoctors && searchDoctors.length > 0"
        @click="getNextDoctors"
      >
        {{ $t("ShowMore") }}
      </h1>
    </section>

    <!-- ============================================================ -->
    <!-- Popups -->
    <!-- ============================================================ -->
    <PackageDetail v-if="selectedPackage.ID" id="PackageDetail" :PackageID="selectedPackage.ID" />

    <vs-popup fullscreen title="" :active.sync="showPopup">
      <HospitalSurgeries :itemModel="ItemModel" v-if="showPopup" @closePop="showPopup = false" />
    </vs-popup>

  </div>
</template>

<script>
// ===== Store Modules =====
import moduleMedicalPackage from "@/store/medicalPackage/moduleMedicalPackage.js";
import moduleMedicalPackageCategory from "@/store/settings/MedicalPackageCategory/moduleMedicalPackageCategory.js";
import moduleCountry from "@/store/settings/country/moduleCountry.js";
import moduleHospital from "@/store/hospital/moduleHospital.js";
import moduleSurgery from "@/store/settings/surgery/moduleSurgery.js";
import moduleSurgeryCategory from "@/store/settings/surgeryCategory/moduleSurgeryCategory.js";
import modulePatient from "@/store/Patient/modulePatient.js";
import moduleDoctor from "@/store/doctor/moduleDoctor.js";
import moduleSpecialty from "@/store/settings/specialty/moduleSpecialty.js";
import moduleCity from "@/store/settings/city/moduleCity.js";

// ===== Components =====
import packageCard from "@/components/home/packageCardV2.vue";
import packageCardOne from "@/components/home/packageCard.vue";
import imageLazy from "@/components/image_lazy.vue";
import PackageDetail from "@/views/package/PackageDetail.vue";
import SurgeryAndTreatmentsList from "@/views/Patient/Surgery/SurgeryAndTreatmentsList.vue";
import HospitalSurgeries from "@/views/Patient/Surgery/HospitalSurgeriesPopup.vue";
import DoctorList from "@/views/appointment/search/DoctorList.vue";
import { domain } from "@/gloabelConstant.js";

export default {
  components: {
    packageCard,
    packageCardOne,
    imageLazy,
    PackageDetail,
    SurgeryAndTreatmentsList,
    HospitalSurgeries,
    DoctorList,
  },

  data() {
    return {
      baseURL: domain,
      EnglishLan: false,

      // ===== 1) Packages =====
      selectedPackage: {},
      packageSearch: {
        MedicalPackageCategorID: "",
        CountryID: "",
        HospitalID: "",
        ValidDate: null,
        IsPublished: true,
      },

      // ===== 2) Surgery =====
      showPopup: false,
      IsShowMoreSurgery: true,
      ItemModel: { Surgeries: [] },
      surgerySearch: {
        SurgeryCategoryID: "",
        SurgeryID: "",
        CountryID: "",
        HospitalID: "",
        filterID: "",
        PageSize: 10,
        PageNumber: 1,
        SurgeryActive: true,
      },

      // ===== 3) Doctors =====
      doctorSearchModel: {
        SpecialtyID: "",
        CountryID: "",
        CityID: "",
        DoctorID: "",
        IsPaging: true,
        PageNumber: 1,
        PageSize: 10,
        ForAppointment: true,
      },
      IsShowMoreDoctors: true,
    };
  },

  computed: {
    windowWidth() {
      return this.$store.state.windowWidth;
    },
    // 1) Packages
    medicalPackages() {
      return this.$store.state.MedicalPackageList.medicalPackages;
    },
    // 2) Surgery
    surgeryHospitals() {
      return this.$store.state.SurgeryList.hospitals || [];
    },
    // 3) Doctors
    searchDoctors() {
      return this.$store.state.DoctorList.searchDoctors;
    },
  },

  methods: {
    // ==================== 1) Packages ====================
    OpenPackage(packageModel) {
      this.$router.push({ name: 'PackageDetail', params: { PackageID: packageModel.ID } });
    },
    searchPackages() {
      this.selectedPackage = {};
      this.$store.dispatch("MedicalPackageList/SearchMedicalPackage", this.packageSearch);
    },

    // ==================== 2) Surgery ====================
    searchSurAndTreat() {
      this.$vs.loading();
      this.$store
        .dispatch("SurgeryList/SearchHospitalsPaging", this.surgerySearch)
        .then((res) => {
          this.$vs.loading.close();
          if (!this.surgeryHospitals || this.surgeryHospitals.length == 0) {
            this.$vs.notify({
              title: this.$t("NoData"),
              text: this.$t("NoDataToshow"),
              iconPack: "feather",
              icon: "icon-alert-circle",
              color: "warning",
            });
          }
          if (res.data.Data.length == 0) {
            this.IsShowMoreSurgery = false;
          }
        });
    },
    getNextHospitals() {
      this.surgerySearch.PageNumber++;
      this.searchSurAndTreat();
    },
    getSurgeries(ID, HospitalID) {
      var obj = {};
      obj.SurgeyCategoryID = ID;
      obj.HospitalID = HospitalID;
      this.$store
        .dispatch("SurgeryList/GetAlHospitalSurgeyByCategory", obj)
        .then((res) => {
          if (res.data == undefined)
            this.ItemModel.Surgeries = res[0].data.Data;
          else
            this.ItemModel.Surgeries = res.data.Data;
          this.ItemModel.CatName = this.ItemModel.Surgeries[0].Surgery.SurgeryCategory.Name;
          this.showPopup = true;
        });
    },

    // ==================== 3) Doctors ====================
    startSearchDoctor() {
      this.doctorSearchModel.PageNumber = 1;
      this.IsShowMoreDoctors = true;
      this.$store.commit("DoctorList/SET_SearchDoctor", []);
      this.searchDoctor();
    },
    getNextDoctors() {
      this.doctorSearchModel.PageNumber++;
      this.searchDoctor();
    },
    searchDoctor() {
      this.$vs.loading();
      this.$store
        .dispatch("DoctorList/SearchDoctorsPaging", this.doctorSearchModel)
        .then((res) => {
          this.$vs.loading.close();
          if (this.searchDoctors.length == 0) {
            this.$vs.notify({
              title: this.$t("NoData"),
              text: this.$t("NoDataToshow"),
              iconPack: "feather",
              icon: "icon-alert-circle",
              color: "warning",
            });
          }
          if (res.data.Data.length == 0) {
            this.IsShowMoreDoctors = false;
          }
        });
    },

    // ==================== URL: countryId ====================
    initCountryFromRoute() {
      var id = null;
      if (this.$route.query.countryId) {
        id = parseInt(this.$route.query.countryId);
      }
      if (this.$route.params.countryId) {
        id = parseInt(this.$route.params.countryId);
      }
      if (id) {
        this.packageSearch.CountryID = id;      // باكدجات
        this.surgerySearch.CountryID = id;      // جراحات
        this.doctorSearchModel.CountryID = id;  // دكاترة
      }
    },
  },

  created() {
    // 1) Read the URL
    this.initCountryFromRoute();

    this.EnglishLan =
      localStorage.getItem("SaveLang") == "en" ||
      localStorage.getItem("SaveLang") == null;

    // 2) تسجيل كل الـ Modules
    const modulesToRegister = [
      ["MedicalPackageCategoryList", moduleMedicalPackageCategory],
      ["CountryList", moduleCountry],
      ["HospitalList", moduleHospital],
      ["MedicalPackageList", moduleMedicalPackage],
      ["SurgeryCategoryList", moduleSurgeryCategory],
      ["SurgeryList", moduleSurgery],
      ["patientList", modulePatient],
      ["DoctorList", moduleDoctor],
      ["SpecialtyList", moduleSpecialty],
      ["CityList", moduleCity],
    ];
    modulesToRegister.forEach(([name, mod]) => {
      if (!mod.isRegistered) {
        this.$store.registerModule(name, mod);
        mod.isRegistered = true;
      }
    });

    // ==================== Execute Search Auto ====================

    // --- 1) Packages ---
    this.packageSearch.ValidDate = new Date();
    this.packageSearch.IsPublished = true;
    this.searchPackages();

    // --- 2) Surgery ---
    this.$store.commit("SurgeryList/SET_SearchHospitals", []);
    this.$store.dispatch("SurgeryList/GetSurgerysByCategory", { SurgeryCategoryID: null });
    this.searchSurAndTreat();

    // --- 3) Doctors ---
    this.$store.commit("DoctorList/SET_SearchDoctor", []);
    this.$store.commit("DoctorList/SET_Doctor", []);
    this.searchDoctor();
  },

  mounted() {},
};
</script>

<style>
.section-title {
  text-align: center;
  margin: 30px 0;
}
#packages .vx-col { padding: unset; }
#packages .vx-row { padding: unset; margin: unset; }
.hospitalListMobil { padding-top: 20px; }
</style>